import React from "react";
import { Link } from "react-router-dom";
import backimg from "../assets/register/registration.webp";
import image10 from "../assets/home-images/Group3.svg";
import image2 from "../assets/home-images/Frame-line.svg";
import america from "../assets/register/Amarican-flag.png";
import canada from "../assets/register/Canada-flag.png";



const Register = () => {
  return (
    <>
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[500px] flex flex-col justify-center items-start px-6 py-16 md:px-12 lg:px-20"
        style={{ backgroundImage: `url(${backimg})` }}
      >
        <div className="flex flex-col gap-6 max-w-2xl" data-aos="fade-down">
          <h1
            className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-snug"
            style={{ wordSpacing: "5px" }}
            data-aos="fade-in"
          >
            Select Your Region to Register
          </h1>

          <p
            className="text-white text-base md:text-lg leading-relaxed max-w-[650px]"
            data-aos="fade-in"
          >
            To provide you with the best services and support tailored to your location, please select your region below to proceed with registration.
          </p>
        </div>
      </div>

      <div className="flex flex-col justify-start px-4 md:px-10 lg:px-10 py-8 mt-8">
        <h1 className="text-lg md:text-3xl font-bold text-[#1A5298] w-3/2 md:max-w-[650px]">
          Choose Your Region
        </h1>
      </div>

      <div className="container mx-auto p-4">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6" data-aos="zoom-in-down">
          <div className="flex flex-col items-center">
            <img
              src={america}
              className="w-full max-w-[400px] h-auto"
              alt="American Flag"
            />
            <p className="text-black text-xl text-center max-w-[400px] mt-2">
            Unlock specialized services for businesses and individuals in the U.S.
            </p>
            <Link
              to={"https://benchtrack.ai/loginselect"} target="_blank"
              className="w-[140px] px-6 py-2 mt-2 mb-20 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold
                             hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base
                             text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
            >
              Register Now
            </Link>
          </div>

          {/* Canada Section */}
          <div className="flex flex-col items-center">
            <img
              src={canada}
              className="w-full max-w-[400px] h-auto"
              alt="Canada Flag"
            />
            <p className="text-black text-xl text-center max-w-[400px] mt-2">
            Get access to our expert solutions designed for Canadian users.
            </p>
            <Link
              to={"https://benchtrack.ai/loginselect"} target="_blank"
              className="w-[140px] px-6 py-2 mt-2 mb-20 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold
                             hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base
                             text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
            >
              Register Now
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="flex flex-col justify-start px-4 md:px-10 lg:px-10 py-8 mt-8">
          <img className="mb-2 w-20 max-h-10" src={image2} alt="" />
          <h1 className="text-lg md:text-3xl font-bold text-[#1A5298] w-3/2 md:max-w-[650px]">
            Why Register?
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4 md:px-10 py-10">
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >

            <h2 className="text-[#1A5298] max-w-[220px] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Access exclusive resources and tools
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Enhance IT Workflows"
              />
            </div>
          </div>

          {/* Box 2 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] max-w-[259px] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Get personalized support for your region
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Optimize Employee Workflows"
              />
            </div>
          </div>

          {/* Box 3 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Stay updated with the latest solutions and innovations
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Improve Customer Workflows"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Register;